import { useDispatch } from "react-redux"
import {
    reportConcernLoading,
    reportConcernFailure,
    reportConcernSuccess,
    contactSupportLoading,
    contactSupportFailure,
    contactSupportSuccess,
} from "@redux/slices/supportSlice"
import { reportConcernSupport } from "../services/support/reportConcernSupport"
import { contactSupport } from "../services/support/contactSupport"
import { notify } from "src/utils/notify"

const useSupport = () => {
    const dispatch = useDispatch()

    const handleReportConcern = async (data) => {
        try {
            dispatch(reportConcernLoading())
            await reportConcernSupport(data)
            dispatch(reportConcernSuccess())
            notify("Report concern sent successfully", "success")
        } catch (error) {
            dispatch(reportConcernFailure(error.message))
            notify("Report concern failed", "error")
        }
    }

    const handleContactSupport = async (data) => {
        try {
            dispatch(contactSupportLoading())
            await contactSupport(data)
            dispatch(contactSupportSuccess())
            notify("Contact support sent successfully", "success")
        } catch (error) {
            dispatch(contactSupportFailure(error.message))
            notify("Contact support failed", "error")
        }
    }

    return {
        handleReportConcern,
        handleContactSupport,
    }
}

export default useSupport
